module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrBold.2acaed9.woff2";